import bin from './bin';

export default {
	binPage: bin
}
